/**
 * Created by AlexanderC on 6/15/15.
 */

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RavenBrowserDriver = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _AbstractDriver2 = require('./AbstractDriver');

var _Log = require('../Log');

var _raven = require('raven');

var _raven2 = _interopRequireDefault(_raven);

var _url = require('url');

var _url2 = _interopRequireDefault(_url);

var _util = require('util');

var _util2 = _interopRequireDefault(_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Raven/Sentry logging for browser
 *
 * @todo replace it on compile time rather than runtime!
 */
let RavenBrowserDriver = exports.RavenBrowserDriver = function (_AbstractDriver) {
  _inherits(RavenBrowserDriver, _AbstractDriver);

  /**
   * @param {String} dsn
   * @param {Object} options
   */
  function RavenBrowserDriver(dsn) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, RavenBrowserDriver);

    var _this = _possibleConstructorReturn(this, (RavenBrowserDriver.__proto__ || Object.getPrototypeOf(RavenBrowserDriver)).call(this));

    options = _util2.default._extend(options, {
      maxMessageLength: 256
    });

    _raven2.default.config(RavenBrowserDriver._prepareDsn(dsn), options).install();
    return _this;
  }

  /**
   * @todo: tmp hook, remove it before persisting frontend config
   *
   * Remove password from url to not expose it into browser
   *
   * @param {String} dsn
   * @returns {String}
   */


  _createClass(RavenBrowserDriver, [{
    key: 'log',


    /**
     * @param {String} msg
     * @param {String} level
     * @param {*} context
     */
    value: function log(msg, level, context) {
      let nativeLevel = RavenBrowserDriver._mapLevel(level);

      _raven2.default.captureMessage(msg, {
        level: nativeLevel,
        extra: context,
        tags: {
          originalLevel: level
        }
      });
    }

    /**
     * @param {String} level
     * @returns {string}
     * @private
     */

  }], [{
    key: '_prepareDsn',
    value: function _prepareDsn(dsn) {
      let parsedDsn = _url2.default.parse(dsn);
      parsedDsn.auth = parsedDsn.auth.split(':')[0];

      return _url2.default.format(parsedDsn);
    }
  }, {
    key: '_mapLevel',
    value: function _mapLevel(level) {
      let nativeLevel = 'info';

      switch (level) {
        case _Log.Log.EMERGENCY:
        case _Log.Log.CRITICAL:
          nativeLevel = 'fatal';
          break;
        case _Log.Log.ALERT:
        case _Log.Log.WARNING:
        case _Log.Log.NOTICE:
          nativeLevel = 'warning';
          break;
        case _Log.Log.ERROR:
          nativeLevel = 'error';
          break;
        case _Log.Log.INFO:
          nativeLevel = 'info';
          break;
        case _Log.Log.DEBUG:
          nativeLevel = 'debug';
          break;
      }

      return nativeLevel;
    }
  }]);

  return RavenBrowserDriver;
}(_AbstractDriver2.AbstractDriver);


//////////////////
// WEBPACK FOOTER
// ../~/deep-log/lib.compiled/Driver/RavenBrowserDriver.js
// module id = 408
// module chunks = 0